import { qzTrayConnectionApi } from "../../api";

/**
 * 🌐 QzTrayConnectionService
 *
 * Gestiona las operaciones de diagnóstico y monitoreo de conexión
 * entre el backend y el cliente local QZ Tray.
 *
 * ✅ Funcionalidades principales:
 * - Probar conexión puntual (Ping)
 * - Obtener estado general de conexión
 * - Obtener estado en vivo (monitor)
 * - Reintentar conexión manual
 * - Verificar compatibilidad de versión
 */
const QzTrayConnectionService = {
  /**
   * 🧪 Prueba rápida de conexión (Ping)
   * GET /api/qztray/connection/ping
   */
  testConnection: async () => {
    const response = await qzTrayConnectionApi.fetchCustom(`/ping`);
    return response.data;
  },

  /**
   * 📊 Obtener estado general
   * GET /api/qztray/connection/status
   */
  getStatus: async () => {
    const response = await qzTrayConnectionApi.fetchCustom(`/status`);
    return response.data;
  },

  /**
   * 📈 Obtener estado en vivo (Monitor)
   * GET /api/qztray/connection/status/live
   */
  getLiveStatus: async () => {
    const response = await qzTrayConnectionApi.fetchCustom(`/status/live`);
    return response.data;
  },

  /**
   * ♻️ Reintentar conexión
   * POST /api/qztray/connection/reconnect
   */
  reconnect: async () => {
    const response = await qzTrayConnectionApi.addCustom(`/reconnect`, {});
    return response.data;
  },

  /**
   * 🧩 Verificar compatibilidad de versión
   * GET /api/qztray/connection/version
   */
  checkVersion: async () => {
    const response = await qzTrayConnectionApi.fetchCustom(`/version`);
    return response.data;
  },
};

export default QzTrayConnectionService;
